<template>
  <!-- Conteneur principal du composant, avec classes dynamiques issues du content -->
  <div v-if="newRegFlow" class="modal-container" :class="jel_getClassObject(content)">
    <div class="modal-btn-wrapper">
      <!-- Bouton déclencheur de la modale, affiché seulement si un libellé est fourni -->
      <button
        v-if="content.libBtn"
        type="button"
        class="modal-trigger-btn btn w-xs-auto w-md-auto hauteur px-4 my-2 btn-primaire"
        @click="isModalOpen = true"
      >
        <span>{{ content.libBtn }}</span>
      </button>
    </div>

    <!-- Overlay de la modale — un clic en dehors de la boîte ferme la modale -->
    <div v-if="isModalOpen" class="modal-overlay" @click.self="closeModal">
      <div
        class="modal-create-account"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
      >
        <!-- Bouton de fermeture (croix) -->
        <button type="button" class="modal-close" aria-label="Fermer" @click="closeModal">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M4 20L20 4" stroke="black" stroke-width="2" stroke-linecap="round" />
            <path d="M20 20L4 4" stroke="black" stroke-width="2" stroke-linecap="round" />
          </svg>
        </button>

        <!-- Partie supérieure : titre + texte descriptif -->
        <div class="mca-top">
          <!-- id ajouté pour le aria-labelledby sur le dialog -->
          <h3 id="modal-title">{{ content.modalTitre }}</h3>
          <!-- v-html utilisé intentionnellement pour du contenu riche (HTML depuis le CMS) -->
          <div v-if="modalText" class="mca-text" v-html="modalText"></div>
        </div>

        <!-- Partie inférieure : bouton d'inscription -->
        <div class="mca-bottom">
          <button
            type="button"
            class="modal-auth-btn btn hauteur px-4 my-2"
            :disabled="isLoading"
            @click="onSignup"
          >
            <!-- Indicateur de chargement pendant l'appel Auth0 -->
            <span>{{ isLoading ? '...' : content.modalLibBtn }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { signupWithAuth0 } from '@/services/api/auth/authService';
import { getPromoFromQueryParams } from '@/helpers/AppHelpers';
import { getProductSourceFromQueryParams } from '@/helpers/ProductSourceHelpers';
import i18n from '@/js/i18n';
import store from '@/store';
import promo from '@/services/api/compte/promo';

export default {
  name: 'BoutonSignUp',

  props: {
    content: { type: Object, required: true },
  },

  data() {
    // Détection de la langue courante (i18n ou navigateur), normalisée en minuscules
    const lang = (i18n?.locale || navigator.language || '').toLowerCase();
    const isFr = lang.startsWith('fr');

    return {
      isFr,
      isModalOpen: false,
      isLoading: false,
      auth0Config: {
        domain: process.env.VUE_APP_CIAM_DOMAIN,
        clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
        locale: isFr ? 'fr-CA' : 'en',
        promoCode: null,
        productSource: null,
        redirectUri: (() => {
          const langPath = isFr ? 'fr/inscription/transition' : 'en/registration/transition';
          return `${process.env.VUE_APP_PROXY_URL_POD}/${langPath}`;
        })(),
      },
    };
  },

  computed: {
    // Texte HTML  de la modale (null-safe via ??  pour éviter un v-html sur undefined)
    modalText() {
      return this.content?.modalTexte ?? '';
    },
    newRegFlow() {
      return process.env.VUE_APP_NEW_REG_FLOW === 'true';
    },
    promoCodeParam() {
      return getPromoFromQueryParams() || store.state.compte.codePromo;
    },
    productSourceParam() {
      return getProductSourceFromQueryParams() || store.state.compte.productSource;
    },
  },

  methods: {
    /** Ferme la modale et réinitialise son état */
    closeModal() {
      this.isModalOpen = false;
    },
    async updatePromoConfig() {
      try {
        const validPromo = await promo.validerPromo(this.promoCodeParam);
        if (validPromo?.promoCode) {
          this.auth0Config.promoCode = validPromo.promoCode;
        }
      } catch (err) {
        store.commit('promo/SET_IS_PROMO_NOT_VALID', true);
      } finally {
        store.commit('promo/SET_IS_PROMO_NOT_VALID', false);
      }
    },
    async onSignup() {
      this.isLoading = true;
      try {
        if (getPromoFromQueryParams()) {
          if (this.promoCodeParam) await this.updatePromoConfig();
        } else {
          this.auth0Config.promoCode = this.promoCodeParam;
        }
        if (this.productSourceParam) this.auth0Config.productSource = this.productSourceParam;
        console.log(this.auth0Config);
        await signupWithAuth0(this.auth0Config);
        this.closeModal();
      } catch (err) {
        console.error('Erreur formulaire:', err?.code || err);
      } finally {
        store.commit('promo/SET_IS_PROMO_NOT_VALID', false);
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-container {
  display: flex;
  justify-content: center;
  margin: 1rem 0;
}

.modal-btn-wrapper {
  display: flex;
  flex-direction: column;
}

.modal-btn-wrapper button {
  max-width: 300px;
  margin: 0 auto;
}

.modal-close {
  position: absolute;
  top: 24px;
  right: 24px;
  appearance: none;
  border: none;
  background-color: transparent;
  cursor: pointer;
}

.modal-create-account {
  position: relative;
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  width: 90%;
  max-width: 400px;
}

.modal-trigger-btn {
  background-color: #a6ecff;
  border-color: #80e4ff;
  border-radius: 2rem;
  line-height: 1.5;
  padding: 0.5rem 0.75rem;
}

.mca-top h3 {
  color: #192872;
  font-family: 'graphik_bold';
  font-size: 24px;
  font-weight: 700;
  line-height: 130%;
  padding-top: 0;
  padding-bottom: 16px;
  margin: 0;
  width: 85%;
}

.mca-text ::v-deep ul {
  padding: 0 2rem 24px;
  margin: 0;
}

.mca-text ::v-deep ul li,
.mca-text ::v-deep ul li p {
  color: #000233;
  font-size: 16px;
  line-height: 150%;
  margin: 0;
}

.modal-auth-btn {
  background-color: #192872;
  border-color: #192872;
  width: 100%;
  margin: 0 !important;
  cursor: pointer;
}

.modal-auth-btn:hover {
  box-shadow: 0 0 0 3px #a6ecff;
  background-color: #101948;
}

.modal-auth-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.modal-auth-btn span {
  font-family: 'graphik_medium', Arial, Helvetica, sans-serif;
  font-weight: 400;
  color: #a6ecff;
  font-size: 16px;
}

.modal-trigger-btn span {
  color: #192872;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 2, 51, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

@media (max-width: 425px) {
  .modal-close {
    transform: scale(0.8);
    right: 16px;
  }

  .mca-top h3 {
    font-size: 18px;
  }

  .mca-text ::v-deep ul {
    padding: 0 16px 24px;
  }

  .mca-text ::v-deep ul li p {
    font-size: 14px;
  }
}
</style>
